import FormLabel from "~/components/login/formLabel/FormLabel";
import Select from "~/components/mantine/select/Select";
import {
  buildFrequencyOptions,
  parseFrequencyOverride,
  toFrequencySelectValue,
} from "~/helpers/frequency";

type FrequencySelectProps = {
  label?: string;
  description?: React.ReactNode;
  defaultSeconds?: number | null;
  value?: number | null;
  onChange: (v: number | null) => void;
  disabled?: boolean;
  searchable?: boolean;
  clearable?: boolean;
};

const FrequencySelect = ({
  label = "Crawl Frequency",
  description,
  defaultSeconds,
  value,
  onChange,
  disabled,
  searchable = true,
  clearable = true,
}: FrequencySelectProps) => {
  return (
    <Select
      label={
        <>
          <FormLabel label={label} />
          {description}
        </>
      }
      data={buildFrequencyOptions(defaultSeconds)}
      searchable={searchable}
      clearable={clearable}
      disabled={disabled}
      value={toFrequencySelectValue(value)}
      onChange={(val) => onChange(parseFrequencyOverride(val))}
    />
  );
};

export default FrequencySelect;
